// extracted by mini-css-extract-plugin
export var clickableWrapper = "_29-2";
export var placeholderIcon = "_29-3";
export var thumbnailCanvas = "_29-1";
export var thumbnailWrapper = "_29-0";